const projects = [
  {
    name: 'Magnify',
    description: 'A single platform for all the courses.',
    link: 'https://github.com/magnifydev/magnify',
  },
  {
    name: 'RavyAPI.py',
    description:
      'A simple and dynamic asynchronous Python wrapper for the Ravy API.',
    link: 'https://github.com/GoogolGenius/ravyapi.py',
  },
  {
    name: 'Scripty',
    description: 'Envision a Discord bot.',
    link: 'https://github.com/scriptydev/prescripty',
  },
  {
    name: 'Fintrack',
    description:
      'Financial planning app for the FBLA Coding & Programming event.',
    link: 'https://github.com/GoogolGenius/fintrack',
  },
  {
    name: 'Chronos',
    description:
      '4324 Lost in Time FIRST Tech Challenge robot for INTO THE DEEP.',
    link: 'https://github.com/GoogolGenius/chronos/tree/teleop',
  },
];

export default projects;
